export default __webpack_public_path__ + "static/media/logo-white.345d1352e56fe00e52a7f41e2d5100cd.png";